import { useTranslation } from '@sib/i18n';
import { PreviewableFile } from '@sib/types';
import { NoDataProps, Button, NoData as BaseNoData } from '@sib/ui';
import { Download } from '@sib/ui/icons';
import { downloadFileFromUrl } from '@sib/utils';

interface NoDataPropsWithFile extends NoDataProps {
  file?: PreviewableFile;
}

export const NoData = ({ file, ...props }: NoDataPropsWithFile) => {
  const { t } = useTranslation();

  const handleDownload = () =>
    file?.fileUrl && downloadFileFromUrl(file.fileUrl, file.name);

  return (
    <BaseNoData
      {...props}
      {...(file?.fileUrl && {
        actions: (
          <Button
            onClick={handleDownload}
            className="inline-flex items-center gap-2"
          >
            <Download className="size-4" />
            {t('download.title')}
          </Button>
        ),
      })}
    />
  );
};
